
import Api from "@/api/userService";
import BasicInfo from "@/components/BasicInfo.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import LogBags from "@/components/LogBags.vue";
import ReStart from "@/components/ReStart.vue";
import SchemaDetails from "@/components/SchemaDetails.vue";
import Snap from "@/components/Snap.vue";
import SnapRecordList from "@/components/SnapRecordList.vue";
import Supply from "@/components/Supply.vue";
import TaskInformation from "@/components/TaskInfo.vue";
import MapView from "@/components/WebglMapView";
import controlMapElements from "@/components/controlMapElements.vue";
import ConstantsType from "@/constant/ConstantsType";
import ResultCodeType from "@/constant/ResultCodeType";
import BaseResultBean from "@/model/BaseResultBean";
import CleanTaskingInfo, {
  FloorCompositeTask,
  FloorTaskStatus,
  SupplyTaskStatus,
} from "@/model/CleanTaskingInfo";
import TaskInfo from "@/model/TaskInfo";
import routerName from "@/router/routerName";
import { dateFormat } from "@/utils/MyUtils";
import {
  showToast,
  toast_error_type,
  toast_success_type,
} from "@/utils/ShowCompUtils";
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "VehicleControl",
  components: {
    ReStart,
    MapView,
    // Snap,
    LogBags,
    ErrorMessage,
    BasicInfo,
    SnapRecordList,
    controlMapElements,
    TaskInformation,
    Supply,
    SchemaDetails,
  },
  setup() {
    const { t } = useI18n();

    const showInputDialog = ref<boolean>(false);
    const sleepTime = ref("");
    const route = useRoute();
    const scaleValue = ref<number>(0);
    const mapName = ref<string>("");
    const floorName = ref<string>("");
    const carVin = route.query && (route.query.vin as string);
    const carStatus = route.query && (route.query.status as string);
    const SnapRecordListRef = ref();
    const taskName = ref<string>("");
    const returnTaskStatus = ref<string>("");
    const cleanModeName = ref<string>("");
    const taskProgress = ref<string>("");
    const startTime = ref<string>("");
    const progress = ref<number>(0);
    const cleanTaskStatus = ref<number>(0);
    const supplyTaskTatus = ref<string>("");
    const floorSelectMapId = ref<string>();
    const supplyTaskStatus = ref<SupplyTaskStatus>();
    const snapRecordF = () => {
      SnapRecordListRef.value.snapRecordF();
    };
    const cleanTaskRfidPoint = ref();
    const floorTaskStatus = ref<FloorTaskStatus>();
    // 地图元素显示隐藏start
    const showvirtualwall = ref<boolean>(false);
    const showpath = ref<boolean>(false);
    const showfunctionAreas = ref<boolean>(false);
    const showfunctionpoints = ref<boolean>(false);
    const toggleVirtualWallsMethod = (val: boolean) => {
      showvirtualwall.value = val;
    };
    const togglePathsMethod = (val: boolean) => {
      showpath.value = val;
    };
    const toggleFunctionAreasMethod = (val: boolean) => {
      showfunctionAreas.value = val;
    };
    const toggleFunctionpointsMethod = (val: boolean) => {
      showfunctionpoints.value = val;
    };
    // 地图元素显示隐藏end
    const floorClickMap = (id: string) => {
      floorSelectMapId.value = id;
    };

    const getScale = (val: number) => {
      scaleValue.value = Math.round((1.4 / val) * 10) / 10; //四舍五入
    };

    const setCombineTask = (val: CleanTaskingInfo, taskInfo: TaskInfo) => {
      if (taskInfo?.task_name) {
        taskName.value = taskInfo.task_name;
      } else {
        taskName.value = "";
      }
      if (val.result?.clean_task_status?.clean_mode) {
        cleanModeName.value = val.result?.clean_task_status.clean_mode;
      } else {
        cleanModeName.value = "";
      }
      const progress = val.result?.clean_task_status?.task_completion
        ? Math.round(val.result?.clean_task_status.task_completion * 100)
        : 0;
      taskProgress.value = t("schedule") + progress + "%";
      const start_time = val.result?.clean_task_status?.start_time;
      if (start_time > 0) {
        startTime.value =
          t("starttime") +
          "：" +
          dateFormat("YYYY-mm-dd HH:MM:SS", new Date(start_time));
      } else {
        startTime.value = "";
      }
    };

    const getMyMapFloorRunTaskInfo = (val: CleanTaskingInfo) => {
      //根据选择的mapId获取多楼层任务中的组合任务Id
      let taskInfo: FloorCompositeTask | undefined;
      const tempMapId = floorSelectMapId.value ? floorSelectMapId.value : "";
      const floorList = val.result?.floor_task_status?.composite_task_list;
      if (floorList?.length > 0) {
        floorList.some((val) => {
          if (val.map_id == tempMapId) {
            taskInfo = val;
            return true;
          } else {
            return false;
          }
        });
      }
      return taskInfo;
    };

    const setFloorTaskInfo = (val: CleanTaskingInfo) => {
      const taskInfo = getMyMapFloorRunTaskInfo(val);
      if (taskInfo) {
        const name = val?.result?.floor_task_status?.floor_task_name;
        if (name) {
          taskName.value = name;
        } else {
          taskName.value = "";
        }
        const mode = val?.result?.floor_task_status?.clean_mode;
        if (mode) {
          cleanModeName.value = mode;
        } else {
          cleanModeName.value = "";
        }
        const progress = val?.result?.floor_task_status?.task_completion
          ? Math.round(val?.result?.floor_task_status.task_completion * 100)
          : 0;
        taskProgress.value = t("schedule") + progress + "%";
        const start_time = val?.result?.floor_task_status?.start_time;
        if (start_time > 0) {
          startTime.value =
            t("starttime") +
            "：" +
            dateFormat("YYYY-mm-dd HH:MM:SS", new Date(start_time));
        } else {
          startTime.value = "";
        }
      }
    };

    const listenTaskIngInfo = (val: CleanTaskingInfo, taskInfo: TaskInfo) => {
      supplyTaskStatus.value = val.result?.supply_task_status;
      floorTaskStatus.value = val.result?.floor_task_status;
      cleanTaskRfidPoint.value = val.result?.rfid_point;
      cleanTaskStatus.value = val.result?.clean_task_status?.task_status;
      if (
        val.result?.supply_task_status?.task_status == 0 ||
        val.result?.supply_task_status?.task_status == 1
      ) {
        supplyTaskTatus.value = t("supplymission");
      } else {
        supplyTaskTatus.value = "";
      }
      if (val.result?.return_task_status?.task_status == 1) {
        returnTaskStatus.value = t("returndockingpoint");
      } else {
        returnTaskStatus.value = "";
      }
      setCombineTask(val, taskInfo);
      setFloorTaskInfo(val);
    };

    const getMapName = (val: string) => {
      mapName.value = val;
    };
    const getFloorName = (val: string) => {
      floorName.value = val;
    };

    const setSleepParameter = (time: number) => {
      Api.changeParameter(carVin, 2, 23, time).then((res: BaseResultBean) => {
        if (res?.err_no == ResultCodeType.success_200) {
          showToast(t("successfullyset"), toast_success_type);
        } else {
          showToast(t("settingfailed"), toast_error_type);
        }
      });
    };

    const submitSleepTime = () => {
      showInputDialog.value = false;
      const time = sleepTime.value;
      const isNumber =
        !isNaN(parseInt(time)) && Number.isInteger(parseFloat(time));
      if (isNumber) {
        const timeNum = Number(time);
        if (timeNum >= 900 && timeNum <= 24 * 60 * 60) {
          setSleepParameter(timeNum);
        } else {
          showToast(t("sleeptimeerrorhint"), toast_error_type);
        }
      } else {
        showToast(t("sleeptimeerrorhint"), toast_error_type);
      }
    };

    return {
      carVin,
      snapRecordF,
      SnapRecordListRef,
      toggleVirtualWallsMethod,
      showvirtualwall,
      togglePathsMethod,
      showpath,
      toggleFunctionAreasMethod,
      showfunctionAreas,
      toggleFunctionpointsMethod,
      showfunctionpoints,
      getScale,
      scaleValue,
      mapName,
      getMapName,
      listenTaskIngInfo,
      taskName,
      cleanModeName,
      taskProgress,
      supplyTaskTatus,
      cleanTaskStatus,
      returnTaskStatus,
      startTime,
      cleanTaskRfidPoint,
      getFloorName,
      floorName,
      floorTaskStatus,
      floorClickMap,
      floorSelectMapId,
      supplyTaskStatus,
      ConstantsType,
      routerName,
      showInputDialog,
      sleepTime,
      submitSleepTime,
      t,
    };
  },
});
